(function () {
  function refreshBar(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    if (!sectionId) return;

    fetch(`${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}sections=${sectionId}`)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newBar = doc.querySelector('[data-free-shipping-topbar]');
        if (newBar) bar.innerHTML = newBar.innerHTML;
      })
      .catch(function () {});
  }

  function refreshAll() {
    document.querySelectorAll('[data-free-shipping-topbar]').forEach(refreshBar);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
  }
})();
